var path = '/app/pages/account/account.html';
var html = "<div class=\"container\" style=\"min-height: 440px\">\n  <ui-view></ui-view>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;